const buildings = [
	{
		"id": "way/334749670",
		"title": "Briggs Technology Building",
		"campus": "Davidson",
		"popup": {
			"title": "Briggs Technology Building",
			"linkedscenes": [
				{
					"scene": "scene_Davidson_Robotics",
					"title": "Electronics Engineering Technology"
				}
			],
			"driveLocation": {
				"lat": "35.864877766381404",
				"lng": "-80.18098193065318"
			}
		}
	},
	{
		"id": "way/334749673",
		"title": "Brinkley Building",
		"campus": "Davidson",
		"popup": {
			"title": "Brinkley Building",
			"linkedscenes": [
				{
					"scene": "scene_Davidson_Cosmopology",
					"title": "Cosmetology"
				},
				{
					"scene": "scene_Davidson_Gym",
					"title": "Brinkley Gym"
				},
				{
					"scene": "scene_Davidson_Weight_Room",
					"title": "Fitness Center"
				}
			],
			"driveLocation": {
				"lat": "35.86419184115513",
				"lng": "-80.1825960532508"
			}
		}
	},
	{
		"id": "way/334749669",
		"title": "Brooks Student Center",
		"campus": "Davidson",
		"popup": {
			"title": "Brooks Student Center",
			"linkedscenes": [
				{
					"scene": "scene_Davidson_Student_Center",
					"title": "Student Center"
				},
				{
					"scene": "scene_Davidson_Student_Lounge",
					"title": "Student Lounge"
				}
			],
			"driveLocation": {
				"lat": "35.86529437737969",
				"lng": "-80.18230147507384"
			}
		}
	},
	{
		"id": "way/334749671",
		"title": "Finch Building",
		"campus": "Davidson",
		"popup": {
			"title": "Finch Building",
			"linkedscenes": [
				{
					"scene": "scene_Davidson_Electronics",
					"title": "Industrial Systems Technology"
				},
				{
					"scene": "scene_Davidson_HVAC",
					"title": "Air Conditioning, Heating, [br]and Refrigeration Technology"
				}
			],
			"driveLocation": {
				"lat": "35.864597422948826",
				"lng": "-80.18165740114195"
			}
		}
	},
	{
		"id": "way/333922747",
		"title": "Gee Building",
		"campus": "Davidson",
		"popup": {
			"title": "Gee Building",
			"linkedscenes": [
				{
					"scene": "scene_Davidson_Classroom",
					"title": "Active Learning Classroom"
				},
				{
					"scene": "scene_Davidson_Dental",
					"title": "Dental Assisting"
				}
			],
			"driveLocation": {
				"lat": "35.865382763957605",
				"lng": "-80.17994121592174"
			}
		}
	},
	{
		"id": "way/334749675",
		"title": "Kirk Child Development Center",
		"campus": "Davidson",
		"popup": {
			"title": "Kirk Child Development Center",
			"driveLocation": {
				"lat": "35.86598307515209",
				"lng": "-80.18353667622446"
			}
		}
	},
	{
		"id": "way/334749667",
		"title": "Love Building",
		"campus": "Davidson",
		"popup": {
			"title": "Love Building",
			"linkedscenes": [
				{
					"scene": "scene_Davidson_Student_Advacement",
					"title": "Support & Retention Services"
				},
				{
					"scene": "scene_Davidson_Tutor",
					"title": "Learning Commons"
				}
			],
			"driveLocation": {
				"lat": "35.86599505250871",
				"lng": "-80.18148812968123"
			}
		}
	},
	{
		"id": "way/334749666",
		"title": "Mendenhall Building",
		"campus": "Davidson",
		"popup": {
			"title": "Mendenhall Building",
			"linkedscenes": [
				{
					"scene": "scene_Davidson_Admissions",
					"title": "Enrollment Center"
				},
				{
					"scene": "scene_Davidson_Advising_",
					"title": "Academic Advising [br]& Career Development"
				}
			],
			"driveLocation": {
				"lat": "35.865953106824264",
				"lng": "-80.18219070139064"
			}
		}
	},
	{
		"id": "way/334749674",
		"title": "Public Safety Services Building",
		"campus": "Davidson",
		"popup": {
			"title": "Public Safety Services Building",
			"driveLocation": {
				"lat": "35.864956683811364",
				"lng": "-80.18348602861066"
			}
		}
	},
	{
		"id": "way/334749668",
		"title": "Reich Building",
		"campus": "Davidson",
		"popup": {
			"title": "Reich Building",
			"driveLocation": {
				"lat": "35.866026608742864",
				"lng": "-80.18094123820535"
			}
		}
	},
	{
		"id": "way/334749676",
		"title": "Rittling Conference Center",
		"campus": "Davidson",
		"popup": {
			"title": "Rittling Conference Center",
			"driveLocation": {
				"lat": "35.86682848348343",
				"lng": "-80.18055762116387"
			}
		}
	},
	{
		"id": "way/334749672",
		"title": "Sinclair Building",
		"campus": "Davidson",
		"popup": {
			"title": "Sinclair Building",
			"linkedscenes": [
				{
					"scene": "scene_Davidson_CNC_2",
					"title": "Computer Integrated Machining"
				},
				{
					"scene": "scene_Davidson_Welding",
					"title": "Welding Technology"
				},
				{
					"scene": "scene_Davidson_Zooology",
					"title": "Zoo Science Technology"
				},
				{
					"scene": "scene_Davidson_Aquarium",
					"title": "Aquarium Science Technology"
				}
			],
			"driveLocation": {
				"lat": "35.86487942799823",
				"lng": "-80.18273915097798"
			}
		}
	},
	{
		"id": "way/616138689",
		"title": "Smith Health Sciences Center",
		"campus": "Davidson",
		"popup": {
			"title": "Smith Health Sciences Center",
			"linkedscenes": [
				{
					"scene": "scene_Davidson_Exam_Room",
					"title": "Nursing"
				},
				{
					"scene": "scene_Davidson_Blood_Work",
					"title": "Medical Laboratory Technology"
				},
				{
					"scene": "scene_Davidson_Exam_Room_2",
					"title": "Medical Assisting"
				},
				{
					"scene": "scene_Davidson_Pharmacy",
					"title": "Pharmacy Technology"
				},
				{
					"scene": "scene_Davidson_Astehics",
					"title": "Esthetics Technology"
				},
				{
					"scene": "scene_Davidson_Massage",
					"title": "Therapeutic Massage"
				},
				{
					"scene": "scene_Davidson_Nursing",
					"title": "Nurse Aide"
				}
			],
			"driveLocation": {
				"lat": "35.86786063038597",
				"lng": "-80.1819774835489"
			}
		}
	},
	{
		"id": "way/333922744",
		"title": "Transportation Technology Building",
		"campus": "Davidson",
		"popup": {
			"title": "Transportation Technology Building",
			"linkedscenes": [
				{
					"scene": "scene_Davidson_Automotive",
					"title": "Automotive and Diesel [br]& Heavy Equipment Technology"
				}
			],
			"driveLocation": {
				"lat": "35.86805557028457",
				"lng": "-80.18036889799356"
			}
		}
	},
	{
		"id": "way/498325562",
		"title": "Administration Building",
		"campus": "Davie",
		"popup": {
			"title": "Administration Building",
			"driveLocation": {
				"lat": "35.87102422564668",
				"lng": "-80.55501662714272"
			}
		}
	},
	{
		"id": "way/909453184",
		"title": "Davie Community Building",
		"campus": "Davie",
		"popup": {
			"title": "Davie Community Building",
			"linkedscenes": [
				{
					"scene": "scene_Davidson_Davie_Library",
					"title": "Library - Davie"
				},
				{
					"scene": "scene_Davidson_Davie_Student_Lounge",
					"title": "Student Lounge - Davie"
				}
			],
			"driveLocation": {
				"lat": "35.87167638771425",
				"lng": "-80.55470964077566"
			}
		}
	},
	{
		"id": "way/909453183",
		"title": "Gantt Building",
		"campus": "Davie",
		"popup": {
			"title": "Gantt Building",
			"driveLocation": {
				"lat": "35.87105447557087",
				"lng": "-80.55358540663521"
			}
		}
	},
	{
		"id": "way/498325564",
		"title": "Health & Technology Building",
		"campus": "Davie",
		"popup": {
			"title": "Health & Technology Building",
			"linkedscenes": [
				{
					"scene": "scene_Davidson_Davie_Welding",
					"title": "Welding Technology - Davie"
				},
				{
					"scene": "scene_Davidson_Davie_Nursing_1",
					"title": "Practical Nurse Education - Davie"
				},
				{
					"scene": "scene_Davidson_Davie_Nursing_2",
					"title": "Surgical Technology & Central [br]Sterile Processing - Davie"
				}
			],
			"driveLocation": {
				"lat": "35.87081243973149",
				"lng": "-80.55539828397809"
			}
		}
	}
]

module.exports = {
    buildings: buildings
}

// { 
//  id: "way/103743098",
//  title:'John R. Fallon Field',
//  linkedscene: 'scene_ualbany_sports',
//  driveLocation: {lng: -73.828866,
//  lat: 42.6812451},
//  walkLocation: { lat: 42.6817438,
//  lng: -73.8257942},
//  content: "[p]Content[/p]"
// }